import { render, staticRenderFns } from "./Racers.vue?vue&type=template&id=530ab43e&scoped=true&"
import script from "./Racers.vue?vue&type=script&lang=js&"
export * from "./Racers.vue?vue&type=script&lang=js&"
import style0 from "./Racers.vue?vue&type=style&index=0&id=530ab43e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530ab43e",
  null
  
)

export default component.exports